import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
} from 'intact';
import {getRestProps} from '../utils';
import {makeStyles} from './styles';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className, children} = this.get();
    const classNameObj = {
        'k-diagram': true,
        [className]: className,
        [makeStyles()]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this)
    }, [
        _$ce(2, 'div', children, 0, 'k-diagram-scheme'),
        _$ce(2, 'div', null, 1, 'k-diagram-canvas', null, null, this.canvasRef)
    ]);
};